module.exports = __webpack_public_path__ + "static/img/Tom-Stewart.843bb9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom-Stewart.jpg
// module id = HjXG
// module chunks = 0